import React from 'react';
import JsonView from './JsonView';
import Util from '../Util';
import $ from 'jquery';

class SheldonCfg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: '',
      path: '',
      content: '',
    };
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleButtonClick(type) {
    let { ip } = this.props.hostInfo;
    let hostInfo = this.props.hostInfo;

    if (this.unmounted) return;

    if (hostInfo.isVPNKskType && !Util.isValidIpAddress(ip)) {
      this.setState({
        content: <span style={{ color: 'red' }}>Invalid ip: {ip}</span>,
      });
      return;
    }
    let kskapi = Util.getKskApiPath(hostInfo);
    let payapi = Util.getPayApiPath(hostInfo);
    let printapi = Util.getPrintApiPath(hostInfo);
    let capui = Util.getCapUIPath(hostInfo);

    let path = '';
    switch (type) {
      case 'cfg':
        path = `${kskapi}/sync/cfg`;
        break;
      case 'dbcfg':
        path = `${kskapi}/ksk/cmddbcfg`;
        break;
      case 'kskdata':
        path = `${kskapi}/ksk/cmdkskdata`;
        break;
      case 'getkskdata':
        path = `${kskapi}/sync/getkskdata`;
        break;
      case 'gettqsummary':
        path = `${kskapi}/sync/gettqsummary`;
        break;
      case 'cmdalive':
        path = `${kskapi}/ksk/cmdalive`;
        break;
      case 'probe':
        path = `${kskapi}/ksk/cmdprobe`;
        break;
      case 'probe1':
        path = `${kskapi}/sync/probe1`;
        break;
      case 'localtime':
        path = `${kskapi}/sync/localtime`;
        break;
      case 'ksk/info':
        path = `${kskapi}/ksk/info`;
        break;
      case 'capui/settings.json':
        path = `${capui}/settings.json`;
        break;
      case 'payapi/alive':
        path = `${payapi}/alive`;
        break;
      case 'printapi/alive':
        path = `${printapi}/alive`;
        break;
      case 'listprinters':
        path = `${kskapi}/sync/listprinters`;
        break;
      case 'printapi/printers':
        path = `${printapi}/printers`;
        break;
    }

    if (this.inProgress) {
      this.setState({
        content: (
          <div>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <div>Request in Progress!</div>
          </div>
        ),
      });
      return; // stop when other request in progress
    }

    this.setState({
      type: type,
      path: path,
      content: <i className='fa fa-spinner fa-spin fa-3x fa-fw' />,
    });

    this.inProgress = true;

    $.ajax({ url: path, dataType: 'json' })
      .always(() => {
        this.inProgress = false;
      })
      .done((data) => {
        let content = <JsonView title={path} data={data} shouldExpandNode={() => true} />;

        if (type === 'dbcfg' && data.data) {
          let o = data.data;

          let kskcfg = null;
          if (o.kskcfg && o.kskcfg.length) {
            kskcfg = {};
            for (let e of o.kskcfg) {
              kskcfg[e.name] = e.value;
            }
          }

          let sfecfg = null;
          if (o.sfecfg && o.sfecfg.length) {
            sfecfg = {};
            for (let e of o.sfecfg) {
              sfecfg[e.type] = e.value;
            }
          }

          let printcfg = null;
          if (o.printcfg && o.printcfg.length) {
            printcfg = o.printcfg;
          }

          content = (
            <div className='pure-u-g'>
              {o.kskloc ? (
                <div className='pure-u-1-2'>
                  <JsonView
                    title={'kioskloc'}
                    data={o.kskloc}
                    hideRoot={false}
                    collectionLimit={40}/>
                </div>
              ) : null}
              {kskcfg ? (
                <div className='pure-u-1-2'>
                  <JsonView title={'kskcfg'} data={kskcfg} hideRoot={false} collectionLimit={40} />
                </div>
              ) : null}
              {sfecfg ? (
                <div className='pure-u-1-2'>
                  <JsonView title={'sfecfg'} data={sfecfg} hideRoot={false} />
                </div>
              ) : null}
              {printcfg ? (
                <div className='pure-u-1-2'>
                  <JsonView title={'printcfg'} data={printcfg} />
                </div>
              ) : null}
              <div className='pure-u-1-2'>
                <JsonView title={path} data={data} />
              </div>
            </div>
          );
        }

        if (type === 'kskdata' && data) {
          let o = data;

          let menulist = null;
          // Comment out the following menu list because it may not be correct
          // since new menu data comes from menu table and not kskdata table
          // if (o.menulist && o.menulist.length) {
          //   menulist = {};
          //   for (let e of o.menulist) {
          //     menulist[e.service] = e.tts + ' ' + e.ttl;
          //   }
          // }

          let pgdlist = null;
          if (o.pgdlist && o.pgdlist.length) {
            pgdlist = {};
            for (let e of o.pgdlist) {
              pgdlist[e.service + ' ' + e.name] = e.inames;
            }
          }

          content = (
            <div>
              {menulist ? <JsonView title={'menu'} data={menulist} hideRoot={true} /> : null}
              {pgdlist ? <JsonView title={'intent'} data={pgdlist} hideRoot={true} /> : null}
              <JsonView title={path} data={data} />
            </div>
          );
        }

        if (type === 'listprinters' && data.data) {
          let printers = data.data.map((obj) => obj.printer);
          content = (
            <div>
              {printers ? <JsonView title={'printers'} data={printers} hideRoot={true} /> : null}
              <JsonView title={path} data={data} />
            </div>
          );
        }

        this.setState(
          {
            content: content,
          },
          () => {
            // let $content = $(this.refs.content);
            // $content.scrollTop($content[0].scrollHeight); // scroll to bottom
          }
        );
      })
      .fail((jqXHR) => {
        this.setState({
          content: <span style={{ color: 'red' }}>{jqXHR.responseText}</span>,
        });
      });
  }

  render() {
    let { panelHeight } = this.props;
    let { type } = this.state;

    return (
      <div className='sheldon-content-wrapper'>
        <h2>Config</h2>
        <div style={{ margin: '20px 0' }}>
          For quering configs from kskdb, kiosk apps/services etc.
        </div>
        <div className='sheldon-buttons'>
          <button
            className={type === 'dbcfg' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'dbcfg')}
          >
            kskdb Config
          </button>
          <button
            className={type === 'kskdata' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'kskdata')}
          >
            Intent
          </button>
          <button
            className={type === 'getkskdata' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'getkskdata')}
          >
            getkskdata
          </button>
          <button
            className={type === 'cfg' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'cfg')}
          >
            cfg
          </button>
{/*
           <button className={type === 'gettqsummary' ? 'pure-button pure-button__selected' : 'pure-button'}
                  onClick={this.handleButtonClick.bind(this, 'gettqsummary')}>
            TransQue Summary
          </button>
          <button className={type === 'cmdalive' ? 'pure-button pure-button__selected' : 'pure-button'}
                  onClick={this.handleButtonClick.bind(this, 'cmdalive')}>
            Check Transaction Server
          </button>
*/}
          {/*       // same as probe1
           <button className={type === 'probe' ? 'pure-button pure-button__selected' : 'pure-button'}
           onClick={this.handleButtonClick.bind(this, 'probe')}>
           probe
           </button>
           */}
          <button
            className={type === 'probe1' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'probe1')}
          >
            OS/DB/Java Versions
          </button>
          <button
            className={type === 'localtime' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'localtime')}
          >
            Local Time
          </button>
          <div>
            <button
              className={type === 'ksk/info' ? 'pure-button pure-button__selected' : 'pure-button'}
              onClick={this.handleButtonClick.bind(this, 'ksk/info')}
            >
              ksk/info
            </button>
            <button
              className={
                type === 'capui/settings.json' ? 'pure-button pure-button__selected' : 'pure-button'
              }
              onClick={this.handleButtonClick.bind(this, 'capui/settings.json')}
            >
              capui/settings.json
            </button>
            <button
              className={
                type === 'payapi/alive' ? 'pure-button pure-button__selected' : 'pure-button'
              }
              onClick={this.handleButtonClick.bind(this, 'payapi/alive')}
            >
              payapi/alive
            </button>
            <button
              className={
                type === 'printapi/alive' ? 'pure-button pure-button__selected' : 'pure-button'
              }
              onClick={this.handleButtonClick.bind(this, 'printapi/alive')}
            >
              printapi/alive
            </button>
{/*
            <button className={type == 'listprinters' ? 'pure-button pure-button__selected' : 'pure-button'}
                    onClick={this.handleButtonClick.bind(this, 'listprinters')}>
              kskapi/printers
            </button>
*/}
            <button className={type === 'printapi/printers' ? 'pure-button pure-button__selected' : 'pure-button'}
                    onClick={this.handleButtonClick.bind(this, 'printapi/printers')}>
              printapi/printers
            </button>
          </div>
        </div>
        <div className='sheldon-content'>
          {/*<div style={{fontWeight: 600, paddingTop: '20px'}}>{this.state.path}</div>*/}
          <div style={{ height: panelHeight - 280, overflow: 'auto' }} ref='content'>
            {this.state.content}
          </div>
        </div>
      </div>
    );
  }
}

export default SheldonCfg;



// WEBPACK FOOTER //
// ./src/components/SheldonCfg.js